import { render, staticRenderFns } from "./SolicitacaoOcorrencia.vue?vue&type=template&id=65189fb9&scoped=true&"
import script from "./SolicitacaoOcorrencia.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoOcorrencia.vue?vue&type=style&index=0&id=65189fb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65189fb9",
  null
  
)

export default component.exports